module.exports = __webpack_public_path__ + "img/4-2.d5502a38.jpg";